const e=e=>{if(!Array.isArray(e))return"";return e.map((e=>[e.type||"",e.value||""].filter(Boolean).join(":"))).join("|").replace(/[_\s]/g,"-").replace(/,(?:-\s*)/g,",").toLowerCase()};export{e as parseItemVariant};
